import React from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  FaUserCog,
  FaRobot,
  FaUserGraduate,
  FaMobile,
  FaChalkboardTeacher,
  FaShieldAlt,
  FaApple,
  FaGooglePlay
} from "react-icons/fa";
import "../../styles/app-download.css";

const Services = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Function to handle navigation to sections
  const handleSectionClick = (e, sectionId) => {
    e.preventDefault();

    // If already on homepage, scroll to section
    if (location.pathname === "/") {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // Navigate to homepage with scroll instruction
      navigate("/", { state: { scrollToSection: sectionId } });
    }
  };

  const services = [
    {
      id: 1,
      icon: <FaUserCog />,
      title: "Admin Portal",
      description:
        "Comprehensive web portal for managing school operations, including courses, classes, performance tracking and many more.",
      link: "/school-management-system",
      isExternalLink: true
    },
    {
      id: 2,
      icon: <FaMobile />,
      title: "Mobile Apps",
      description:
        "Native iOS and Android mobile applications for students and faculty, providing easy access to information and communication.",
      link: "/coaching-management-system",
      isExternalLink: true
    },
    {
      id: 3,
      icon: <FaRobot />,
      title: "Intelligent Learning Assistant",
      description:
        "AI driven personalized learning experiences, instant doubt resolution, and actionable data insights to transform educational outcomes.",
    },
    {
      id: 4,
      icon: <FaUserGraduate />,
      title: "Chhaatr App",
      description:
        "Dedicated mobile application for students to access their courses, timetable, study materials, assessments, and communicate with faculty and peers.",
      appStoreLink: "https://apps.apple.com/in/app/ps-chhaatr/id6745966365",
      playStoreLink: "https://play.google.com/store/apps/details?id=com.bojack.chhaatrpathshalasanchalakapp&pcampaignid=web_share",
      hasAppLinks: true
    },
    {
      id: 5,
      icon: <FaChalkboardTeacher />,
      title: "Adhyapak App",
      description:
        "Dedicated mobile application for faculty to manage their schedule, subjects, study materials, review assessments, and communicate with students.",
      appStoreLink: "https://apps.apple.com/in/app/ps-adhyapak/id6745964284",
      playStoreLink: "https://play.google.com/store/apps/details?id=com.bojack.adhyapakpathshalasanchalakapp&pcampaignid=web_share",
      hasAppLinks: true
    },
    // {
    //   id: 5,
    //   icon: <FaCalendarAlt />,
    //   title: "Scheduling & Planning",
    //   description:
    //     "Comprehensive scheduling system for classes, exams, events, and parent-teacher meetings with automated notifications.",
    // },
    // {
    //   id: 6,
    //   icon: <FaChartLine />,
    //   title: "Performance Analytics",
    //   description:
    //     "Advanced analytics and reporting tools to track student performance, attendance trends, and institutional growth.",
    // },
    {
      id: 6,
      icon: <FaShieldAlt />,
      title: "Secure Infrastructure",
      description:
        "Robust security features protecting sensitive student and institutional data while ensuring compliance with regulations.",
    },
  ];

  return (
    <section id="services" className="services section-padding">
      <div className="container">
        <div className="section-header">
          <h2>Our Features</h2>
          <p>
            Comprehensive school management solution for educational
            institutions
          </p>
        </div>

        <div className="services-grid">
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <div className="free-tag">FREE</div>
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              {service.isExternalLink ? (
                <Link to={service.link} className="service-link">
                  Learn More
                </Link>
              ) : service.hasAppLinks ? (
                <div className="app-store-links">
                  <a 
                    href={service.appStoreLink} 
                    className="app-store-btn" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    aria-label={`Download ${service.title} on App Store`}
                  >
                    <FaApple /> App Store
                  </a>
                  <a 
                    href={service.playStoreLink} 
                    className="play-store-btn" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    aria-label={`Download ${service.title} on Google Play`}
                  >
                    <FaGooglePlay /> Google Play
                  </a>
                </div>
              ) : (
                <a
                  href="/#contact"
                  className="service-link"
                  onClick={(e) => handleSectionClick(e, "contact")}
                >
                  Learn More
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
